import {  Component,  OnInit,  ViewChild,  Output,  EventEmitter} from '@angular/core';
import {  TicketsService} from 'src/app/services';
import {  TicketDetails,  UserDetail,  AccessUserInfo} from 'src/app/models';
import {  FilterUtils} from 'primeng/utils'
import {  HttpClient,  HttpHeaders} from '@angular/common/http';
import {  TableModule} from 'primeng/table';
import {  Table} from 'primeng/table';
import {  FacilityService, MessageService} from 'src/app/services'


@Component({
  selector: 'bart-ticket-manager',
  templateUrl: './ticket-manager.component.html',
  styleUrls: ['./ticket-manager.component.scss']

})
export class TicketManagerComponent implements OnInit {
datevariable: Date=new Date();
  Loding: boolean = false;
  today = new Date();
  sixmonthsagodate = new Date();
  voidTicketReason = '';
  USERID: number;
  tickets = [];

  @ViewChild('dt2', {
    static: false
  }) tableRef: TableModule;
  @ViewChild('dt2', {
    static: false
  }) tableRefdt2: Table;
  @Output() btnKeywordClicked = new EventEmitter();
  displayTicketDetails: boolean = false;
  displayVoidTicketConfirm: boolean = false;
  voidTicketSuccess: boolean = false;
  getDashTicketLoading: boolean = true;
  displayinputValidation: boolean = false;
  TicketMangerData: TicketDetails[] = [];
  public txtkeywordNg: string = '';
  public datebeginNg: Date;
  public dateendNg: Date;
  public ticketAdmin: any;
  public AdminData: any;
  public data: any;
  public TicketMangerColumns: any[];
  public strkeyWord: string;
  public beggingdate: Date;
  public enddate: Date;
  public displayInputModal: boolean = false;
  public Content: string;
  public selectedData: any;
  public IsVisible: boolean = false;
  public SelectedRowData: any[];
  public userInfo: UserDetail;

  public userFacilityIdList: any;

  GETTICKETADMINPARM = {
    ticketStatusId: 2,
    facilityMasterIdList: null,
    ticketSearchStartDate: null,
    ticketSearchEndDate: null,
    userId: 0,
    nextTicketId: null,
    returnTotalCount: 0,
    returnAllRecords: 0,
    bartRoleCode: null,
    maxRecords: 50,
    orderBy: "ticketId desc",
    SearchTerm: null
  };

  constructor(private http: HttpClient, private _ticketService: TicketsService, private facilityService: FacilityService, private messageService: MessageService) {}

  ngOnInit() {

    let today = new Date();
    this.sixmonthsagodate.setDate(this.today.getDate() - 180);
    this.datebeginNg = this.sixmonthsagodate, "mm/dd/yyyy";
    this.dateendNg = this.today;
    FilterUtils['dateRangeFilter'] = (value, filter): boolean => {
      var todaysDate = new Date();
      // get the from/start value
      var s = this.datebeginNg[0].getTime();
      var e;
      if (this.datebeginNg[1]) {
        e = this.datebeginNg[1].getTime() + 86400000;
      } else {
        //e = s + 86400000;
        e = todaysDate.getTime() + 86400000; // use today + 1 day   

      }
      // compare it to the actual values
      return value.getTime() >= s && value.getTime() <= e;
    }

    this.TicketMangerColumns = [{
        field: 'ticketNumber',
        header: 'Ticket#',
        display: 'table-cell'
      },
      {
        field: 'facilityName',
        header: 'Location',
        display: 'table-cell'
      },
      {
        field: 'modelDescription',
        header: 'Model',
        display: 'table-cell'
      },
      {
        field: 'workTypeDescription',
        header: 'Work Type',
        display: 'table-cell'
      },
      {
        field: 'sqaDescription',
        header: 'SQA Code',
        display: 'table-cell'
      },
      {
        field: 'equipmentSerialNumber',
        header: 'Serial#',
        display: 'table-cell'
      },
      {
        field: 'dateCreated',
        header: 'Date Created',
        display: 'none'
      },
      {
        field: 'modifiedByFullname',
        header: 'Last Modified By',
        display: 'none'
      },
    ];

    this.userFacilityIdList = this.facilityService.getCurrentUserFacilityMasterIdList()
    this.userInfo = AccessUserInfo.getUserInfo()

    this.dashTickets();
  }

  public getKeyword() {
    this.TicketMangerData=[];
    this.selectedData=null;
    this.strkeyWord = this.GETTICKETADMINPARM.SearchTerm;
    this.btnKeywordClicked.emit(this.strkeyWord);
    this.beggingdate = this.datebeginNg, "mm/dd/yyyy";
    this.enddate = this.dateendNg, "mm/dd/yyyy";
    let startdate = new Date(this.beggingdate).setHours(0,0,0,0);
    let enddate = new Date(this.enddate).setHours(0,0,0,0);
    if(enddate>0)
    {
    if (enddate < startdate) {
      this.Content = "Date End should be greater than Date Begin.";
      this.displayInputModal = true;
      this.dashTickets();
    }
    else
    {
      this.dashTickets();
    }
  } 
    else {
      this.dashTickets();
    }


  }

  public dashTickets() {
    this.GETTICKETADMINPARM.SearchTerm = this.txtkeywordNg;
    this.GETTICKETADMINPARM.ticketSearchStartDate = this.datebeginNg;
    this.GETTICKETADMINPARM.ticketSearchEndDate = this.dateendNg;
    this.GETTICKETADMINPARM.userId = this.userInfo.userId;
    this.GETTICKETADMINPARM.bartRoleCode = this.userInfo.bartRoleCode;
    this.GETTICKETADMINPARM.facilityMasterIdList = this.userFacilityIdList;
    let dashTickets = this.GETTICKETADMINPARM;
    this.Loding = true;
    this._ticketService.dashTickets(JSON.stringify({
      dashTickets
    })).subscribe((Result: any) => {
        this.TicketMangerData = Result;
        this.Loding = false;
      },
      (respose: Response) => {
        this.Loding = false;
      });
  }
  updateTicket(params: any) {
    this._ticketService.updateTicket(JSON.stringify(params)).subscribe((response: any) => {
      this.dashTickets();

    });
  }


  addTicketNote(params2: any) {
    this._ticketService.addTicketNote(params2).subscribe((response: any) => {
      this.dashTickets();

    });
  }

  voidTicket() {
    this.displayVoidTicketConfirm = true;
  }
  closeClick(eventId: string) {
    this.displayInputModal = false;

  }
  OkClose() {
    this.voidTicketSuccess = false;

  }
  clickrefresh(eventId: string) {
    this.dashTickets();
  }
  voidTicketConfirm(obj) {
    this.displayTicketDetails = false;
    if (this.voidTicketReason != '') {
      var params = {
        "UPDTICKETWATER": {
          "TICKETID": obj.ticketId,
          "USERID": this.userInfo.userId,
          "TICKETFIELDS": {
            "ticketId": obj.ticketId,
            "ticketStatusId": 3
          }
        },
        "INSTICKETWATER": {
          "TICKETID": obj.ticketId,
          "USERID": this.userInfo.userId,
          "TICKETFIELDS": {
            "ticketId": obj.ticketId,
            "ticketStatusId": 3
          }
        },
        "UPDATETICKET": {
          "TICKETID": obj.ticketId,
          "USERID": this.userInfo.userId,
          "TICKETFIELDS": {
            "ticketId": obj.ticketId,
            "ticketStatusId": 3
          }
        },
        "ADDBATCHTICKETPARTS": {
          "TICKETID": obj.ticketId
        },
        "GETTICKETWATER": {
          "TICKETID": obj.ticketId,
          "USERID": this.userInfo.userId,
          "TICKETFIELDS": {
            "ticketId": obj.ticketId,
            "ticketStatusId": 3
          }
        }

      };

      var params2 = {
        "ADDTICKETNOTE": {
          "TicketId": obj.ticketId,
          "Note": this.voidTicketReason,
          "Userid": this.userInfo.userId

        }
      };
      this.updateTicket(params);

      this.addTicketNote(params2);
      this.dashTickets();
      this.displayVoidTicketConfirm = false;
      this.voidTicketReason = '';
      this.voidTicketSuccess = true;
      this.tickets = [];
      this.getDashTicketLoading = true;
      this.dashTickets();
      this.selectedData=null;
    } else {
      this.messageService.showAlertMessage("VALIDATION ERROR:You must provide a reason for voiding the ticket.");
    }
  }
}
